import React from "react";
import ReactAudioPlayer from 'react-audio-player';
import { useDropzone } from 'react-dropzone'
import { awsPostData } from "../aws/aws_integration"
import { DropZone } from "./Image_drop";
import StTextArea from "./stTextArea"
import { checkHotspotType } from "./utils"
import "../../css/popup_data_editor.css"
import GetAppIcon from '@material-ui/icons/GetApp';
import LoadingOverlay from 'react-loading-overlay';

const hotspotStyle = {
    standard: {
        audioLayer: "10",
        areaDisplayStyle: "area",
        audioPlayerVisible: true,
        audioLoop: false,
        audioPlayUntilEnd: false,
        audioContinueOnReEntry: true,
    },
    background: {
        audioLayer: "3",
        areaDisplayStyle: "none",
        audioPlayerVisible: false,
        audioLoop: true,
        audioPlayUntilEnd: false,
        audioContinueOnReEntry: true,
    },
    instructional: {
        audioLayer: "5",
        areaDisplayStyle: "none",
        audioPlayerVisible: false,
        audioLoop: false,
        audioPlayUntilEnd: true,
        audioContinueOnReEntry: true,
    },
    custom: {
        audioLayer: "0",
        areaDisplayStyle: "none",
        audioPlayerVisible: false,
        audioLoop: false,
        audioPlayUntilEnd: false,
        audioContinueOnReEntry: false,
    }
}

export default class PopupDataEditor extends React.Component {

    constructor(props) {
        super();
        this.popupData = props.src;
        this.state = { images: [], uploadingAudio: false };
        if (props.src.images !== undefined) this.state = { images: props.src.images.split(","), uploadingAudio: false  }
        this.handleChange = this.handleChange.bind(this);
        this.handleQuickChange = this.handleQuickChange.bind(this);
    }

    handleChange(event) {
        if (this.popupData[event.target.name] !== event.target.value) {
            this.popupData[event.target.name] = event.target.value
            this.props.onChange(this.popupData)
        }
    }

    handleQuickChange(event) {
        if (this.popupData[event.target.name] !== event.target.value) {
            this.popupData[event.target.name] = event.target.value
            this.props.onQuickChange(this.popupData)
        }
    }

    uploadAudio = file => {
        const fileExtension = file.name.split('.').pop()
        if (fileExtension!='mp3') {
            alert("Only .mp3 files are allowed\n\nAudio file name must end with '.mp3' (lower case)")
        } else {
            const { handleChange } = this
            const { metadata } = this.props
            this.setState({ uploadingAudio : true });

            const getUuid = require('uuid-by-string');
            const sanitizedFileName = `${getUuid(file.name)}.${fileExtension}`;

            awsPostData(file, sanitizedFileName, metadata.audioBaseUrl).then(() => {
                handleChange({ target: { name: "audioFileUrl", value: sanitizedFileName } });
                this.setState({ uploadingAudio : false });
            })
        }
    }

    deleteAudio = () => {
        if (confirm("This will PERMANENTLY DELETE the audio file.\nDo you want to proceed?")) {
            const { handleChange } = this
            handleChange({ target: { name: "audioFileUrl", value: "" } });
            this.setState({});
        }
    }

    imageUpdate = images => {
        this.handleQuickChange({ target: { name: "images", value: images.join() } });
    }

    DropDownTag = () => {
        let selected = checkHotspotType(this.popupData);
        
        const [state, setState] = React.useState(selected);

        const onChange = (event) => {
            const v = event.target.value;
            const { handleChange } = this;
            setState(v)
            for (const style in hotspotStyle[v]) {
                handleChange({ target: { name: style, value: hotspotStyle[v][style] } })
            }
        }

        if (this.popupData.areaDisplayStyle === undefined 
        && this.popupData.audioLayer === undefined) {
            onChange({ target: {value: "standard"}})
        }

        return (
            <select style={{ marginTop: "20px", marginBottom: "20px" }} value={state} onChange={onChange}>
                <option style={{ backgroundColor: "#3388ff" }} value="standard">Standard</option>
                <option style={{ backgroundColor: "#aaaaaa" }} value="background">Background</option>
                <option style={{ backgroundColor: "#666666" }} value="instructional">Instructional</option>
                <option style={{ backgroundColor: "#33dd33" }} value="custom">Custom</option>
            </select>
        );
    };

    Audio = () => {
        const { getRootProps, getInputProps, open } = useDropzone({
            onDrop: (f) => this.uploadAudio(f[0]),
            noClick: true,
            noKeyboard: true
        });
        const { metadata } = this.props
        const url = this.popupData.audioFileUrl;
        if (!url) {
            return (
                <div {...getRootProps({ className: 'dropzone' })}>
                    <input {...getInputProps()} />
                    <button onClick={open} style={{ backgroundColor: "#fff", border: "none", cursor: "pointer", position: "relative" }}>
                        <img src="https://cdn3.iconfinder.com/data/icons/audio-files-8/24/add_music_file_sound_music_audio-512.png" style={{ height: "40px", position: "relative" }} />
                    </button>
                </div>
            );
        }
        const buttonStyle = {
            backgroundColor: "#555",
            color: "white",
            fontSize: "16px",
            border: "none",
            cursor: "pointer",
            borderRadius: "10px"
        }
        return (
            <div style={{ height: "60px" }}>
                <button onClick={() => this.deleteAudio()} style={buttonStyle}>X</button>
                <ReactAudioPlayer src={metadata.audioBaseUrl + url} controls />
                <a href={metadata.audioBaseUrl + url} title={"Download audio file ("+url+")"}>
                    <GetAppIcon />
                </a>
            </div>
        );
    }

    render() {
        const { Audio, DropDownTag, imageUpdate, handleChange, handleQuickChange } = this;
        const { metadata, layer } = this.props;
        const { images } = this.state;

        //console.log(this.popupData.desc)

        return (
            <div>
                <LoadingOverlay active={this.state.uploadingAudio} spinner text={'Uploading '+( (this.popupData.audioFileUrl) ? this.popupData.audioFileUrl: '') +' ...'}>
                <table>
                    <tbody>
                        <tr key="1"><td>Name:</td><td><input className="prettyInput input" type="text" name="title" defaultValue={this.popupData.title} onChange={handleQuickChange} /></td></tr>
                        {layer.feature.geometry.type === "Polygon" ? <div /> : <tr key="2"><td>Radius:</td><td><input className="prettyInput input" type="text" name="radius" defaultValue={this.popupData.radius} onChange={handleChange} /></td></tr>}
                        <tr key="3"><td>Images:</td><td><DropZone imageBaseUrl={metadata.imageBaseUrl} updateImages={imageUpdate} images={images} aspectRatio={1} /></td></tr>
                        <tr key="4"><td>Hotspot Type:</td><td><DropDownTag /></td></tr>
                        <tr key="5"><td>Description:</td><td><StTextArea html={this.popupData.desc} callback={(html) => { handleQuickChange({ target: { name: "desc", value: html } }) }} /></td></tr>
                        <tr key="6"><td>Transcript:</td><td><textarea style={{height:"50px"}} className="popupTextArea" type="text" name="transcript" defaultValue={this.popupData.transcript} onChange={handleQuickChange} /></td></tr>
                        <tr key="7"><td>Audio:</td><td><Audio /></td></tr>
                    </tbody>
                </table>
                </LoadingOverlay>
            </div>
        )
    }
}